
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/tag-container.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-tag-container-demo-tag-container"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/tag-container.md?type=demo')
};